var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.5528 12.5444C34.8545 12.1045 33.9962 12.0655 33.2645 12.4378L30.7945 13.6848C29.8811 14.1451 29.3145 15.0757 29.3145 16.1112V25.8337C29.3145 26.8693 29.8811 27.7982 30.7945 28.2618L33.2628 29.5072C33.5978 29.6798 33.9562 29.7627 34.3145 29.7627C34.7445 29.7627 35.1712 29.6408 35.5528 29.4023C36.2512 28.964 36.6679 28.2043 36.6679 27.3718V14.5765C36.6679 13.7441 36.2512 12.9843 35.5528 12.5444Z",
    fill: "#CC2B52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8425 33.4736H10.1891C6.15235 33.4736 3.33398 30.6902 3.33398 26.7054V15.2418C3.33398 11.2554 6.15235 8.47363 10.1891 8.47363H19.8425C23.8792 8.47363 26.6975 11.2554 26.6975 15.2418V26.7054C26.6975 30.6902 23.8792 33.4736 19.8425 33.4736Z",
    fill: "#CC2B52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/Video.f302632b85b6e8030eaaefa1e101e20e.svg";
export { ForwardRef as ReactComponent };